import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "left-panel" }
const _hoisted_2 = { class: "right-panel" }

import { ref } from "vue";
import TimeList from "../components/TimeList.vue";
import Timer from "../components/Timer.vue";
import Scrambles from "@/components/Scrambles.vue";
import Options from "@/components/Options.vue";
import ModifyTime from "@/components/ModifyTime.vue";
import { useRoute } from "vue-router";
import { useTheme } from "vuetify";
import { type Time } from "@/js/types";

//* vars

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const jscookie = require("js-cookie");
const route = useRoute();
let time = ref<{
    id: number;
    str: string;
    num: number;
    added2: boolean;
    addedDnf: boolean;
}>();
let changeScramble = ref<number>(0);
let timeRemoved = ref<number>(0);
let username = ref<string>("");
let editingOptions = ref<boolean>(false);
let showTimeList = ref<boolean>(false);
let updateChartNum = ref<number>(0);
let currTheme = jscookie.get("theme") ? ref<string>(jscookie.get("theme")) : ref<string>("dark");
let timeChartActive = ref<boolean>(jscookie.get("timeChartActive") === "1");
let timeListChanged = ref<any>([]);
let guestModeChanged = ref<number>(0);
let updateStats = ref<number>(0);
let currentScramble = ref<string>("");
let timerRunning = ref<boolean>(false);
let editingTime = ref<boolean>(false);
let timeModified = ref<Time | null>(null);
let makeChangeToTime = ref<[string, Time] | null>(null);

//* use a prop to send time to TimeList
function addTime(i: { id: number; str: string; num: number; added2: boolean; addedDnf: boolean }) {
    time.value = i;
}

function changeUsernameFunc(newUsername: string, hasGuestChanged: boolean = false) {
    username.value = newUsername.toLowerCase();
    jscookie.set("username", newUsername, { expires: 365 * 10 });
    // if (hasGuestChanged) {
    //     guestModeChanged.value++;
    // }
}

if (jscookie.get("username")) {
    username.value = jscookie.get("username");
}

if (username.value == "") {
    editingOptions.value = true;
}

//* change theme
if (jscookie.get("theme")) {
    let theme = useTheme();
    theme.global.name.value = jscookie.get("theme");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(Options, {
        username: _unref(username),
        onHideOptions: _cache[0] || (_cache[0] = ($event: any) => (_isRef(editingOptions) //@ts-ignore
 ? editingOptions.value = false : editingOptions = false)),
        onUsernameChanged: _cache[1] || (_cache[1] = 
                (i) => {
                    changeUsernameFunc(i, false);
                }
            ),
        onGuestChanged: _cache[2] || (_cache[2] = 
                (i) => {
                    changeUsernameFunc(i, true);
                }
            ),
        onChangedTheme: _cache[3] || (_cache[3] = 
                (i) => {
                    _isRef(currTheme) //@ts-ignore
 ? currTheme.value = i : currTheme = i;
                }
            ),
        onTimeChartChange: _cache[4] || (_cache[4] = 
                (i) => {
                    _isRef(timeChartActive) //@ts-ignore
 ? timeChartActive.value = i : timeChartActive = i;
                    _isRef(updateChartNum) //@ts-ignore
 ? updateChartNum.value++ : updateChartNum++;
                }
            ),
        onStatsModeChanged: _cache[5] || (_cache[5] = ($event: any) => (_isRef(updateStats) //@ts-ignore
 ? updateStats.value++ : updateStats++))
      }, null, 8, ["username"])
    ], 512), [
      [_vShow, _unref(editingOptions)]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(ModifyTime, {
        time: _unref(timeModified),
        onExitTimeModifying: _cache[6] || (_cache[6] = ($event: any) => (_isRef(editingTime) //@ts-ignore
 ? editingTime.value = false : editingTime = false)),
        onModifyTime: _cache[7] || (_cache[7] = 
                (i) => {
                    _isRef(makeChangeToTime) //@ts-ignore
 ? makeChangeToTime.value = i : makeChangeToTime = i;
                }
            )
      }, null, 8, ["time"])
    ], 512), [
      [_vShow, _unref(editingTime) && _unref(timeModified) != null]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(TimeList, {
        style: {"height":"100vh"},
        time: _unref(time),
        username: _unref(username),
        "guest-mode-changed": _unref(guestModeChanged),
        "editing-options": _unref(editingOptions),
        "update-chart": _unref(updateChartNum),
        "show-chart": _unref(timeChartActive),
        makeChangeToTime: _unref(makeChangeToTime),
        updateStats: _unref(updateStats),
        onTimeDeleted: _cache[8] || (_cache[8] = ($event: any) => (_isRef(timeRemoved) //@ts-ignore
 ? timeRemoved.value++ : timeRemoved++)),
        onChangeOptions: _cache[9] || (_cache[9] = 
                (i) => {
                    _isRef(editingOptions) //@ts-ignore
 ? editingOptions.value = i : editingOptions = i;
                }
            ),
        onTimeListChanged: _cache[10] || (_cache[10] = 
                (i) => {
                    _isRef(timeListChanged) //@ts-ignore
 ? timeListChanged.value = i : timeListChanged = i;
                }
            ),
        onModifyTime: _cache[11] || (_cache[11] = 
                (i) => {
                    _isRef(timeModified) //@ts-ignore
 ? timeModified.value = i : timeModified = i;
                    _isRef(editingTime) //@ts-ignore
 ? editingTime.value = true : editingTime = true;
                }
            ),
        onClearModifyArray: _cache[12] || (_cache[12] = ($event: any) => (_isRef(makeChangeToTime) //@ts-ignore
 ? makeChangeToTime.value = null : makeChangeToTime = null))
      }, null, 8, ["time", "username", "guest-mode-changed", "editing-options", "update-chart", "show-chart", "makeChangeToTime", "updateStats"])
    ], 512), [
      [_vShow, (_unref(showTimeList) && _ctx.$vuetify.display.mdAndDown) || _ctx.$vuetify.display.lgAndUp]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Scrambles, {
        class: "pa-0",
        style: {"height":"27vh","width":"100%"},
        "change-scramble": _unref(changeScramble),
        "disable-input": _unref(editingOptions),
        "disable-input2": _unref(showTimeList),
        "timer-running": _unref(timerRunning),
        onShowTimelist: _cache[13] || (_cache[13] = ($event: any) => {
                _isRef(showTimeList) //@ts-ignore
 ? showTimeList.value = true : showTimeList = true;
                _isRef(updateChartNum) //@ts-ignore
 ? updateChartNum.value++ : updateChartNum++;
            }),
        onNewScramble: _cache[14] || (_cache[14] = 
                (i) => {
                    _isRef(currentScramble) //@ts-ignore
 ? currentScramble.value = i : currentScramble = i;
                }
            )
      }, null, 8, ["change-scramble", "disable-input", "disable-input2", "timer-running"]),
      _createVNode(Timer, {
        class: "pa-0",
        style: {"height":"73vh","width":"100%"},
        "remove-time": _unref(timeRemoved),
        "curr-theme": _unref(currTheme),
        "editing-options": _unref(editingOptions),
        showTimeList: _unref(showTimeList),
        "time-list": _unref(timeListChanged),
        "current-scramble": _unref(currentScramble),
        onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(showTimeList) ? (_isRef(showTimeList) //@ts-ignore
 ? showTimeList.value = false : showTimeList = false) : null)),
        onTimeDone: _cache[16] || (_cache[16] = 
                (i) => {
                    addTime(i);
                    _isRef(changeScramble) //@ts-ignore
 ? changeScramble.value++ : changeScramble++;
                }
            ),
        onTimerRunning: _cache[17] || (_cache[17] = 
                (i) => {
                    _isRef(timerRunning) //@ts-ignore
 ? timerRunning.value = i : timerRunning = i;
                }
            )
      }, null, 8, ["remove-time", "curr-theme", "editing-options", "showTimeList", "time-list", "current-scramble"])
    ])
  ], 64))
}
}

})